module.exports = __webpack_public_path__ + "static/media/04.7e891d57.jpg";